import { gql } from '@/__generated__/gql';

export const INVESTMENT_MANAGERS_QUERY = gql(`
  query FatActiveInvestmentsPageInvestmentManagers(
    $page: Int
    $rowsPerPage: Int
    $sort: String
    $order: String
    $managerId: String
    $search: String
    $withCommitments: Boolean
  ) {
    InvestmentManagers(
      page: $page
      rowsPerPage: $rowsPerPage
      sort: $sort
      order: $order
      managerId: $managerId
      search: $search
      withCommitments: $withCommitments
    ) {
      total
      page
      perPage
      managers {
        name
        assetClasses
        countOfFunds
        countOfInvestors
        committedCapital
        percentOfTotalActiveCommmitments
      }
    }
  }
`);

export const INVESTMENTS_QUERY = gql(`
  query FatActiveInvestmentsPageManagerInvestments($managerId: String, $page: Int, $rowsPerPage: Int, $sort: String, $order: String, $search: String) {
    ManagerInvestments(managerId: $managerId, page: $page, rowsPerPage: $rowsPerPage, sort: $sort, order: $order, search: $search) {
      total
      page
      perPage
      totalInvestors
      totalCommittedCapital
      investments {
        id
        managerId
        name
        assetClass {
          id
          name
        }
        maxCalledPercent
        countOfInvestors
        committedCapital
      }
    }
  }
`);
